import { Fragment, useState } from "react"
import { BaseButton } from "components/library/buttons";
import { ApiPaths } from "services/api/ApiPaths";
import useSWR from 'swr';
import { loadPractice, deletePractice } from "../services";
import callApi from "services/api/callApi";
import useToggle from "hooks/useToggle";
import DefaultModal from "components/library/DefaultModal";
import ResetConfirm from "../components/ResetConfirmation";
import useOpenTpsc from "hooks/useOpenTpsc";
import { TDeletePracticeResponse } from "../scenario.model";

const Practice = () => {
    const { isLoading, data: practice, mutate } = useSWR<number>(ApiPaths.PRACTICE, loadPractice)
    const [clearing, setClearing] = useState<boolean>(false)
    const [showReset, setShowReset] = useToggle();
    const { openTpsc } = useOpenTpsc()

    /* istanbul ignore next */
    const clearPractice = async () => {
        setShowReset(false)
        if (practice) {
            setClearing(true)
            const { success, isLoading } = await callApi<TDeletePracticeResponse>("SCENARIO/DELETE", deletePractice())
            success && mutate()
            setClearing(isLoading)
        }
    }
    
    if (!isLoading && practice)
        return <Fragment>
            <BaseButton buttonStyles="is-primary min-width-unset ml-2" fieldId="" labelKey="Buttons.practice" onClick={() => openTpsc(practice)} />
            <BaseButton loading={clearing} buttonStyles="is-text ml-2 " fieldId="" labelKey="Buttons.clear_practice" onClick={setShowReset} />
            <DefaultModal  isOpen={showReset} handleCloseModal={() => setShowReset(false)}>
                <ResetConfirm confirm={clearPractice} isPractice />
            </DefaultModal>
        </Fragment>
    else return <Fragment></Fragment>
}

export default Practice;